import _merge from "lodash/merge";
const getThemeColor = (theme, color) => {
  if ((theme == null ? void 0 : theme.vars.palette) && color in theme.vars.palette) {
    if (color === "text") {
      return theme.vars.palette.text.primary;
    }
    const paletteColor = theme.vars.palette[color];
    if (paletteColor && typeof paletteColor === "object") {
      if ("main" in paletteColor) {
        return paletteColor.main;
      }
      if ("500" in paletteColor) {
        return paletteColor[500];
      }
    }
  }
  return color;
};
const resolveThemeColor = (theme, color) => {
  var _a;
  return {
    ...theme.vars.palette[color],
    contrastText: (_a = theme.vars.palette[color]) == null ? void 0 : _a.contrastText
  };
};
const createResponsiveStyles = (theme, ...values) => {
  const styles = values.map((responsiveStyle) => {
    if (!responsiveStyle) {
      return;
    }
    const styles2 = {
      // Match [0, xs)
      [theme.breakpoints.down("xs")]: responsiveStyle.xs,
      // Match [xs, ∞)
      [theme.breakpoints.up("xs")]: responsiveStyle.xs,
      // Match [sm, ∞)
      [theme.breakpoints.up("sm")]: responsiveStyle.sm,
      // Match [md, ∞)
      [theme.breakpoints.up("md")]: responsiveStyle.md,
      // Match [lg, ∞)
      [theme.breakpoints.up("lg")]: responsiveStyle.lg,
      // Match [xl, ∞)
      [theme.breakpoints.up("xl")]: {
        ...responsiveStyle.xl
      }
    };
    return styles2;
  }).filter((style) => !!style);
  return _merge({}, ...styles);
};
const isThemeDirty = ({
  initialTheme,
  themeFromSetup,
  currentTheme
}) => {
  try {
    const setup = themeFromSetup && Object.keys(themeFromSetup).length > 0 ? JSON.stringify(themeFromSetup) : void 0;
    const init = Object.keys(initialTheme ?? {}).length > 0 ? JSON.stringify(initialTheme) : void 0;
    const curr = JSON.stringify(currentTheme ?? {});
    if (setup && setup !== init) {
      return setup !== curr;
    }
    return init && init !== curr;
  } catch (error) {
    console.error("[ThemeSetup] Failed to check if theme has changed", error);
    return false;
  }
};
const resolveThemeTypographyOptions = (theme) => {
  if (typeof (theme == null ? void 0 : theme.typography) === "function") {
    return void 0;
  }
  return theme == null ? void 0 : theme.typography;
};
const resolveThemeStyleOverrides = (theme, componentName) => {
  var _a, _b, _c;
  const styleOverrides = (_c = (_b = (_a = theme.components) == null ? void 0 : _a[componentName]) == null ? void 0 : _b.styleOverrides) == null ? void 0 : _c.root;
  if (!styleOverrides || typeof styleOverrides !== "object") {
    return void 0;
  }
  return styleOverrides;
};
export {
  createResponsiveStyles,
  getThemeColor,
  isThemeDirty,
  resolveThemeColor,
  resolveThemeStyleOverrides,
  resolveThemeTypographyOptions
};
//# sourceMappingURL=util.js.map
